import { useState } from "react";

export default function QuantitySelector({ quantity ,setQuantity}) {

  const decrementQuantity = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const incrementQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 5px",
        backgroundColor: "white",
        borderRadius: "8px",
        margin: "20px auto",
      }}
    >
      <span style={{ fontSize: "15px", color: "#555555" }}>Quantity</span>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: "6px",
          border: "1px solid #e0e0e0",
          overflow: "hidden",
          backgroundColor: "#f8f9fa",
        }}
      >
        <button
          type="button"
          onClick={decrementQuantity}
          aria-label="Decrease quantity"
          style={{
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            borderRight: "1px solid #e0e0e0",
            backgroundColor: "transparent",
            cursor: "pointer",
            fontSize: "18px",
            color: quantity > 1 ? "#4a5568" : "#a0aec0",
            transition: "background-color 0.2s, color 0.2s",
          }}
          onMouseOver={(e) => {
            if (quantity > 1) e.currentTarget.style.backgroundColor = "#f1f3f5";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          −
        </button>

        <input
          id="quantity-input"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={quantity}
          onChange={handleInputChange}
          style={{
            width: "55px",
            height: "36px",
            border: "none",
            textAlign: "center",
            fontSize: "15px",
            fontWeight: "500",
            backgroundColor: "transparent",
            color: "#2d3748",
            "-moz-appearance": "textfield",
            appearance: "textfield",
          }}
        />

        <style>{`
          /* Remove arrows from number input for Chrome, Safari, Edge, Opera */
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          
          /* Remove arrows for Firefox */
          input[type=number] {
            -moz-appearance: textfield;
          }
        `}</style>

        <button
          type="button"
          onClick={incrementQuantity}
          aria-label="Increase quantity"
          style={{
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            borderLeft: "1px solid #e0e0e0",
            backgroundColor: "transparent",
            cursor: "pointer",
            fontSize: "18px",
            color: "#4a5568",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "#f1f3f5";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          +
        </button>
      </div>
    </div>
  );
}
